import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ConcatModal from '@/components/TabsContacts/zbu/editModal.vue'

const __default__ = { name: 'viewFooterBtn' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  workCode: {
    type: String
  },
  type: {
    type: String
  },
  loading: {
    type: Boolean
  },
  detail: {
    type: Object,
    default: () => {
      return {}
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const concatModalRef = ref()
const router = useRouter()
const route = useRoute()
const emit = __emit

// 新增联系人
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
const successPage = (tag: any) => {
  emit('success', tag)
}
//  编辑
const handleEdit = () => {
  router.push({
    path: '/lbu/leadManage/edit',
    query: {
      clueId: route.query.clueId
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_footer_button, { hideOk: "" }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: handleAddConcat }, {
          default: _withCtx(() => [
            _createTextVNode("新增联系人")
          ]),
          _: 1
        })), [
          [_directive_permission, __props.permissionPage?.concat_add]
        ]),
        (__props.detail && __props.detail.clueStatus !== 1)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              onClick: handleEdit
            }, {
              default: _withCtx(() => [
                _createTextVNode("编辑")
              ]),
              _: 1
            })), [
              [_directive_permission, __props.permissionPage?.edit]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ConcatModal, {
      ref_key: "concatModalRef",
      ref: concatModalRef,
      onSuccess: _cache[0] || (_cache[0] = ($event: any) => (successPage('contact'))),
      contactRefId: _unref(route).query.clueId
    }, null, 8, ["contactRefId"])
  ], 64))
}
}

})